import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "physicalPerson";

export const usePhysicalPersonStore = defineStore(storeName, () => {
  const all = ref([]);
  const { baseFetchOne, baseFetchAll, baseMultipartSave, basePost, baseDelete, watchRemoteResourceChange } = useBase(storeName);

  const empty =  {
    attributes: {},
    relationships: {
      birthCountryId: {data: {}},
      addressCountry: {data: {}},
      industrySector: {data: {}},
      professionId: {data: {}}
    }
  };

  const path = "physical-persons";

  const save = async (resource, callback, errorCallback) => {
    return await baseMultipartSave(path, resource, callback, errorCallback);
  };

  const fetchAll = async (errorCallback, includes = []) => {
    all.value = await baseFetchAll(path, errorCallback, includes, { paginate: true, perPage: 50 });
  };

  const fetchOne = async (id, errorCallback, includes = []) => {
    return await baseFetchOne(path, id, errorCallback, includes);
  };

  const buildReport = async (physicalPersonId, callback, errorCallback, includes = []) => {
    const path = `physical-persons/${physicalPersonId}/reports/physical-persons`;
    const params = {};
    if (includes && includes.length > 0) {
      params.include = Array.isArray(includes) ? includes.join(",") : includes;
    }
    return await basePost(path, {}, callback, errorCallback, params);
  };

  const deleteReport = async (physicalPersonReportId, physicalPersonId, callback, errorCallback) => {
    const path = `physical-persons/${physicalPersonId}/reports/physical-persons`;
    return await baseDelete(path, physicalPersonReportId, callback, errorCallback);
  };

  const watchResourceChanges = async (callback) => {
    await watchRemoteResourceChange(storeName, callback);
  };

  return {
    fetchPhysicalPersons: fetchAll,
    fetchPhysicalPerson: fetchOne,
    savePhysicalPerson: save,
    emptyPerson: empty,
    physicalPersons: all,
    buildReport,
    deleteReport,
    watchResourceChanges
  };
});
